import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { ShippingRate } from '../../shipping/ShippingRate'

@InputType()
export class GetLogisticShippingRatesArgs extends ActionArgs {
  @Field(() => ID)
  logisticId: string
}

export interface IGetLogisticShippingRates extends IAction<ShippingRate[], GetLogisticShippingRatesArgs> {}
